import React from 'react';
import {Navigate} from 'react-router-dom';
import LoginForm from './LoginForm';
import styles from '../Login.module.scss';
import PageTitle from '../../shared/web/PageTitle';
import {useAuthenticationContext} from 'nekst-api';
import PoliciesLinks from './PoliciesLinks';
import GoogleOAuthButton from "./GoogleOAuthButton";
import {SeparatorWithText} from "features/nekst-widgets";
import {SimpleBlock} from "ui-builder";
import { GoogleSignInToggleWrapper } from "feature-toggle";

export default function LoginPage() {

  const authenticationContext = useAuthenticationContext();

  if (!authenticationContext?.user) {
    return (
      <>
        <div className={styles.page}>
          <div className={styles.pageInner}>
            <PageTitle text="Login" />
            <LoginForm />
            <GoogleSignInToggleWrapper>
              <SeparatorWithText text="Or Continue With Google" marginSize="big" />
              <SimpleBlock className={styles.buttons}>
                <GoogleOAuthButton />
              </SimpleBlock>
            </GoogleSignInToggleWrapper>
          </div>
        </div>

        <PoliciesLinks />
      </>
    );
  } else {
    return (<Navigate to="/tasks" replace />);
  }
}
